module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1043.d8eafb56.png";